import Model from './BaseModel';

export default class TrackClassification extends Model {
	resourceName() {
		return 'track_classifications';
	}

	fields() {
		return ['classification', 'race_type'];
	}

	// override the base update for our request specific URL
	update(trackId, data) {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/tracks/${trackId}/classification`,
			method: 'POST',
			data
		});
	}
}
